import React from 'react'
import SectionBase from './SectionBase'

export default () => (
  <SectionBase
    titleText="In addition to training for the American Development Model, numerous courses are available to help you get the most out of your coaching business, and help you make the biggest impact with your athletes. "
    gtmLearnObject={{
      event: 'onboarding-click',
      onboardingCategory: 'onboarding-dashboard',
      onboardingLabel: 'more-coach-training',
      onboardingAction: 'click-learn-more',
    }}
    learnMoreLink="https://support.pga.com/en/articles/6015489-additional-coach-training"
    gtmDoActionObject={{
      event: 'onboarding-click',
      onboardingCategory: 'onboarding-dashboard',
      onboardingLabel: 'more-coach-training',
      onboardingAction: 'click-more-training',
    }}
    doActionLink="https://vt.lightspeedvt.com/share/redirect.cfm?signInURL=https://webservices.lightspeedvt.net/SAML/lsvt/login.aspx?h=pga.onelogin.com&dest=https://vt.lightspeedvt.com/trainingCenter/"
    doActionLinkExternal="true"
    doActionText="Continue Training"
  />
)
